import { useMutation } from "@tanstack/react-query";
import { useNotification } from "@refinedev/core";

import { ApiError } from "@shared/types";
import { PlanMapOption } from "@modules/erpIntegrations/types";
import { getErpErrorMessage } from "@modules/erpIntegrations/utils";

import { editPlanMapOptionService } from "./service";
import { PlanMapOptionPatchPayload, UseEditPlanMapOptionMutationOptions } from "./types";

export function useEditPlanMapOptionMutation(
  options?: UseEditPlanMapOptionMutationOptions
) {
  const { open } = useNotification();

  return useMutation<
    PlanMapOption,
    ApiError,
    { id: number; data: PlanMapOptionPatchPayload }
  >({
    mutationFn: ({ id, data }) => editPlanMapOptionService(id, data),
    onError: (error) => {
      open?.({
        type: "error",
        message: getErpErrorMessage(error),
      });
    },
    ...options,
  });
}
